export enum MutationTypes {
    SET_BLOCK = "SET_BLOCK",
    SET_BLOCK_TITLE_TO_BLOCK = "SET_BLOCK_TITLE_TO_BLOCK",
    SET_BLOCK_HEADER_TO_BLOCK = "SET_BLOCK_HEADER_TO_BLOCK",
    SET_BLOCK_HEADER_SECOND_ROW_TO_BLOCK = "SET_BLOCK_HEADER_SECOND_ROW_TO_BLOCK",

    PUSH_CHILD_TO_BLOCK = "PUSH_CHILD_TO_BLOCK",
    SET_CHILDREN = "SET_CHILDREN",

    DELETE_BLOCK = "DELETE_BLOCK",
    DELETE_BLOCK_TITLE_FROM_BLOCK = "DELETE_BLOCK_TITLE_FROM_BLOCK",
    DELETE_BLOCK_HEADER_FROM_BLOCK = "DELETE_BLOCK_HEADER_FROM_BLOCK",
    DELETE_BLOCK_HEADER_SECOND_ROW_FROM_BLOCK = "DELETE_BLOCK_HEADER_SECOND_ROW_FROM_BLOCK",
    DELETE_CHILD = "DELETE_CHILD",
}
